/**
 * @param {HTMLElement} section
 */
function initProductStepsTabs(section) {
  if (!section || section.dataset.tabsReady === "true") return;

  const buttons = /** @type {HTMLButtonElement[]} */ (
    Array.from(section.querySelectorAll("[data-tab-target]"))
  );
  const panels = /** @type {HTMLElement[]} */ (
    Array.from(section.querySelectorAll("[data-tab-panel]"))
  );

  if (buttons.length === 0 || panels.length === 0) return;

  section.dataset.tabsReady = "true";

  let activeId =
    buttons.find((button) => button.classList.contains("is-active"))?.dataset
      .tabTarget || buttons[0]?.dataset.tabTarget;

  if (!activeId) return;

  /**
   * @param {string} targetId
   * @param {{ immediate?: boolean }} [options]
   */
  const activate = (targetId, options = {}) => {
    if (!targetId) return;

    const immediate = options.immediate === true;
    activeId = targetId;

    buttons.forEach((button) => {
      const isActive = button.dataset.tabTarget === targetId;
      button.classList.toggle("is-active", isActive);
      button.setAttribute("aria-selected", isActive ? "true" : "false");
    });

    panels.forEach((panel) => {
      const isActive = panel.dataset.tabPanel === targetId;

      panel.classList.toggle("is-active", isActive);
      panel.hidden = !isActive;

      if (isActive && !immediate) {
        panel.style.animation = "none";
        panel.offsetHeight;
        panel.style.animation = "";
      }
    });
  };

  section.addEventListener("click", async (event) => {
    const target = /** @type {HTMLElement | null} */ (
      event.target instanceof HTMLElement ? event.target : null
    );
    if (!target) return;

    const button = /** @type {HTMLButtonElement | null} */ (
      target.closest("[data-pst-add-to-cart]")
    );
    if (!button) return;

    const variantId = Number(button.dataset.variantId || "");
    if (!variantId || Number.isNaN(variantId)) return;

    button.classList.add("is-loading");
    button.disabled = true;

    try {
      const response = await fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify({
          id: variantId,
          quantity: 1,
        }),
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(
          data?.description || data?.message || "Cart add failed",
        );
      }

      button.classList.add("is-added");
      setTimeout(() => button.classList.remove("is-added"), 500);

      document.dispatchEvent(
        new CustomEvent("cart:update", {
          bubbles: true,
          detail: {
            resource: data,
            sourceId: `product-steps-tabs-${variantId}`,
            data: {
              source: "product-form-component",
              itemCount: 1,
              productId: button.dataset.productId || "",
              variantId: String(variantId),
            },
          },
        }),
      );
    } catch (error) {
      console.error("Product Steps Tabs add to cart error:", error);
    } finally {
      button.classList.remove("is-loading");
      button.disabled = false;
    }
  });

  buttons.forEach((button, index) => {
    button.addEventListener("click", () =>
      activate(button.dataset.tabTarget || ""),
    );

    button.addEventListener("keydown", (event) => {
      const keyboardEvent = /** @type {KeyboardEvent} */ (event);

      if (
        keyboardEvent.key !== "ArrowRight" &&
        keyboardEvent.key !== "ArrowLeft"
      )
        return;

      keyboardEvent.preventDefault();
      const offset = keyboardEvent.key === "ArrowRight" ? 1 : -1;
      const nextIndex = (index + offset + buttons.length) % buttons.length;
      const nextButton = buttons[nextIndex];
      if (!nextButton) return;

      nextButton.focus();
      activate(nextButton.dataset.tabTarget || "");
    });
  });

  activate(activeId, { immediate: true });
}

document.querySelectorAll(".product-steps-tabs").forEach(initProductStepsTabs);

document.addEventListener("shopify:section:load", (event) => {
  const target = /** @type {Element | null} */ (
    event.target instanceof Element ? event.target : null
  );
  if (!target) return;

  const section = /** @type {HTMLElement | null} */ (
    target.classList.contains("product-steps-tabs")
      ? target
      : target.querySelector(".product-steps-tabs")
  );

  if (section) {
    initProductStepsTabs(section);
  }
});
